import React from 'react';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

function LoadingIndicator() {
  return (
    <Stack py={4} width='100%' alignItems='center' justifyContent='center'>
      <CircularProgress />
    </Stack>
  );
}

export default LoadingIndicator;
